import { render, staticRenderFns } from "./QuestionFill.vue?vue&type=template&id=32952074"
import script from "./QuestionFill.vue?vue&type=script&lang=js"
export * from "./QuestionFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports